import type { AdminAction, Permission, StaffMember } from '@contract';
import { canUse } from '@contract';
import { createContext, useContext } from 'react';

export const StaffContext = createContext<StaffMember | null>(null);

/** The signed-in staff member. Only inside the signed-in layout. */
export function useStaff(): StaffMember {
  const staff = useContext(StaffContext);
  if (!staff) throw new Error('useStaff outside the signed-in layout');
  return staff;
}

export function useCan(action: AdminAction): boolean {
  return canUse(action, useStaff());
}

export function useHas(permission: Permission): boolean {
  return useStaff().permissions.includes(permission);
}
